/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react"
import * as React from "react"
import { RouterChildProps } from "../../commons/interfaces"
import { Result, theme } from "antd"
import Button from "../uiLibrary/Button/Button"
import { resultCss } from "./styles"
import { isRouteErrorResponse, useRouteError } from "react-router-dom"
import { includes } from "lodash"

export const NotFound: React.FC<RouterChildProps> = () => {
	const { token } = theme.useToken()
	return <Result css={resultCss(token)} status="404" title="404" subTitle="Sorry, the page you visited does not exist." />
}

export const GlobalError: React.FC = () => {
	const { token } = theme.useToken()
	const error: any = useRouteError()
	console.error(error)
	let errorMessage: string
	if (isRouteErrorResponse(error)) {
		// error is type `ErrorResponse`
		// @ts-ignore
		errorMessage = error.error?.message || error.statusText
	} else if (error instanceof Error) {
		errorMessage = error.message
	} else if (typeof error === "string") {
		errorMessage = error
	} else {
		console.error(error)
		errorMessage = "Unknown error"
	}
	if (includes(errorMessage, "dynamically imported")) {
		location.reload()
		return
	}
	return (
		<Result css={resultCss(token)} status="error" title="Uh Oh! There seems to be a technical issue" subTitle="We're On It.">
			<Button shape={"round"} onClick={() => location.reload()}>
				Reload Page
			</Button>
		</Result>
	)
}

export const LocalError: React.FC = () => {
	const { token } = theme.useToken()
	return <Result css={resultCss(token)} status="error" title="Something went wrong!" subTitle="We're On It." />
}

export const APIError = () => {
	const { token } = theme.useToken()
	return <Result css={resultCss(token)} status="500" title="500" subTitle="Sorry, something went wrong." />
}

export const NotAuthorised: React.FC<RouterChildProps> = () => {
	const { token } = theme.useToken()
	return <Result css={resultCss(token)} status="403" title="Not Authorized" subTitle="Sorry, you are not authorized to access this page." />
}

export const handleNotAuthorised = (): React.FC<RouterChildProps> | React.ReactElement<any, any> => {
	return <NotAuthorised />
}
